// @ts-nocheck
import { getLabelFallback } from '@utils/utils';
import { useEffect, useState } from 'react';

import sha256 from 'crypto-js/sha256';
import md5 from 'crypto-js/md5';

import { Checkbox } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import * as actions from '@redux-actions/';

import SuccessIconNoBackground from '@images/svg-icons/successIconNoBackground.svg';

interface Props {
    phone1: string;
    handleSubscriptions: any;
}

const PhoneNumberInbox = ({ phone1, handleSubscriptions }: Props) => {
    const userSettings = useSelector((state: RootState) => state.myProfile.userSettings);
    const userSubscriptionCorrect = useSelector((state: RootState) => state.myProfile.userSubscriptionCorrect);
    const userSubscriptionPhoneChanged = useSelector((state: RootState) => state.myProfile.userSubscriptionPhoneChanged);
    const [checked, setChecked] = useState(false);
    const dispatch = useDispatch();
    let userPhoneSub;

    const clickOnCheckbox = () => {
        dispatch(actions.getUserSubscriptionCorrect(false));
        dispatch(actions.getUserSubscriptionPhoneChanged(true));
        dispatch(actions.getUserSubscriptionEmailChanged(false));
        dispatch(actions.getUserSubscriptionPhone(!checked));
        setChecked(!checked);
    };

    useEffect(() => {
        if (!!userSettings && !!userSettings.subscription) {
            setChecked(userSettings.subscription.isUserSubscribedByPhone);
        }
    }, [userSettings])

    return (
        <div className="content-container inbox-phone-number">
            <div className="inbox-phone-number-title">{getLabelFallback('INBOX_PHONE_NUMBER_TITLE_LABEL')}</div>
            <div className="inbox-phone-number-subtitle">{getLabelFallback('INBOX_PHONE_NUMBER_SUBTITLE_LABEL')}</div>
            <div className="inbox-phone-number-value">
                {phone1.replace(/(\d{3})(\d{3})(\d{4})/, "(+1) $1-$2-$3")}

            </div>
            <div className="inbox-phone-number-checkbox">
                <div className="inbox-phone-number-checkbox-left">
                    <Checkbox
                        size="small"
                        inputProps={{
                            'aria-label': 'Phone',
                        }}
                        checked={checked}
                        onChange={() => {
                            if (checked) {
                                userPhoneSub = '0';
                            } else {
                                userPhoneSub = '1';
                            }
                            if (phone1.trim() == "") {
                                tealium_data2track.push({
                                    User_Phone_MD5: '',
                                    User_Phone_SHA256: '',
                                    Events_UserPhoneSub: userPhoneSub
                                });
                            } else {
                                let phone = phone1.replaceAll(/\D/g, '').slice(1);
                                tealium_data2track.push({
                                    User_Phone_MD5: md5(phone).toString(),
                                    User_Phone_SHA256: sha256(phone).toString(),
                                    Events_UserPhoneSub: userPhoneSub
                                });
                            }
                            clickOnCheckbox();
                        }}
                    />
                </div>
                <div className="inbox-phone-number-checkbox-right">
                    <div className="inbox-phone-number-checkbox-right-top">{getLabelFallback('INBOX_CHECKBOX_PHONE_NUMBER_TITLE_LABEL')}</div>
                    <div
                        className="inbox-phone-number-checkbox-right-bottom"
                        dangerouslySetInnerHTML={{ __html: getLabelFallback('INBOX_CHECKBOX_PHONE_NUMBER_SUBTITLE_LABEL') }}
                    ></div>
                </div>
            </div>
            {userSubscriptionCorrect && userSubscriptionPhoneChanged && (
                <div className='inbox-email-success'>
                    {checked && (
                        <div className="success-message">
                            <SuccessIconNoBackground />
                            <span className="secondary-message medium success bold">
                                {getLabelFallback(
                                    'SETTINGS_UPDATE_PASSWORD_FORM_SUCCESS_MESSAGE'
                                )}
                            </span>
                        </div>
                    )}
                    {!checked && (
                        <div className="success-message">
                            <SuccessIconNoBackground />
                            <span className="secondary-message medium success bold">
                                {getLabelFallback(
                                    'INBOX_REMOVE_SUCCESS_MESSAGE'
                                )}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
export default PhoneNumberInbox;
